// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.no-style tr {
    background-color: transparent;
  }
  .no-style {
    border: none;
  }
  
  .no-style th,
  .no-style td {
    border: none;
  }
  
  .no-style thead th,
  .no-style thead td {
    border-bottom-width: 2px;
  }`, "",{"version":3,"sources":["webpack://./src/app/role-recommendation-edit/role-recommendation-edit.component.css"],"names":[],"mappings":";AACA;IACI,6BAA6B;EAC/B;EACA;IACE,YAAY;EACd;;EAEA;;IAEE,YAAY;EACd;;EAEA;;IAEE,wBAAwB;EAC1B","sourcesContent":["\n.no-style tr {\n    background-color: transparent;\n  }\n  .no-style {\n    border: none;\n  }\n  \n  .no-style th,\n  .no-style td {\n    border: none;\n  }\n  \n  .no-style thead th,\n  .no-style thead td {\n    border-bottom-width: 2px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
